import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null
};

export function CuvetteRackReducer(
  state = { cuvetteRack: [] },
  action
) {
  let currentCuvetteRack;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_CUVETTE_RACK" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("cuvetteRack")
      ) {
        currentCuvetteRack =
          state.protocolSection.scene.apparatus.cuvetteRack[
            findIndex(state.protocolSection.scene.apparatus.cuvetteRack, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_CUVETTE_RACK":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("cuvetteRack")) {
        protocolSection.scene.apparatus.cuvetteRack = [
          ...protocolSection.scene.apparatus.cuvetteRack,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.cuvetteRack = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('cuvetteRack')) {
        protocolSection.scene.apparatus.cuvetteRack =
          action.payload.lastState.scene.apparatus.cuvetteRack;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
